<div style="padding: 50px">
  <app-book-form (save)="onSave($event)"></app-book-form>
</div>
